import React, { useState } from "react";
import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "./Header";
import { getIn } from "formik";
import { TextField } from "@material-ui/core";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CBSLOGO from "../../cbs-logo-1.png";
import { CircularProgress, Button } from "@material-ui/core";

const url = process.env.REACT_APP_API_URL;

const generalInfo = [
  {
    label: "First Name",
    name: "patientFirstName",
    type: "text",
    required: true,
  },
  {
    label: "Middle Name",
    name: "patientMiddleName",
    type: "text",
  },
  {
    label: "Last Name",
    name: "patientLastName",
    type: "text",
    required: true,
  },
  { label: "Phone", name: "landPhone", type: "phone", required: true },
  { label: "Email", name: "email", type: "text", required: true },
];

const schema = Yup.object().shape({
  patientFirstName: Yup.string()
    .trim()
    .required("Patient First Name is required"),
  patientLastName: Yup.string()
    .trim()
    .required("Patient Last Name is required"),
  email: Yup.string().required("Email is required").email("Must be a valid Email"),
  landPhone: Yup.string()
    .trim()
    .required("Phone Number is required")
    .transform((value) => value.replace(/[^\d]/g, ""))
    .min(10, "Must be exactly 10 digits")
    .max(10, "Must be exactly 10 digits"),
});

const intialvalues = {
  patientFirstName: "",
  patientMiddleName: "",
  patientLastName: "",
  landPhone: "",
  patientId: "",
  email: ""
};

const PreForm = ({ setPreForm, handlePreFormDetails, preFormDetails }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setError(false);
  };

  const onSubmit = async (values, onSubmitProps) => {
    // console.log(values);
    setLoading(true);

    await axios
      .post(`${url}/cbsApi/saveUser`, values)
      .then((res) => {
        if (res.status === 200 && res.data && res.data.response) {
          handlePreFormDetails(res.data.response);
          setLoading(false);
          setPreForm(false);
        } else {
          if (res.data && res.data.message) {
            setErrorMessage(res.data.message);
          }
          setLoading(false);
          setError(true);
          onSubmitProps.setSubmitting(false);
        }
      })
      .catch((error) => {
        if (error.data && error.data.message) {
          setErrorMessage(error.data.message);
        }
        setLoading(false);
        setError(true);
        onSubmitProps.setSubmitting(false);
      });
  };

  return (
    <div className={loading ? "cbs-form-blur" : ""}>
      <Formik
        initialValues={intialvalues}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {(props) => {
          const {
            values,
            touched,
            error,
            handleChange,
            errors,
            setFieldValue,
          } = props;
          return (
            <Form
              id="cbs-forms"
              noValidate="noValidate"
              style={{ padding: "20px 0px 25px" }}
            >
              <div className="common-input-field">
                <Header />
                <div className="card custom-card">
                  <div className="title">
                  <h5>PATIENT BASIC INFORMATION</h5>
                </div>
                  <div className="row text-center ">
                    {generalInfo.map(
                      ({ label, name, type, required = false }, ind) => {
                        if (type === "text") {
                          return (
                            <div
                              className="form-group col-md-6 col-lg-4"
                              key={name + ind}
                            >
                              <TextField
                                label={label}
                                name={name}
                                onChange={handleChange}
                                value={values[name]}
                                aria-label="text-field"
                                fullWidth
                                error={Boolean(
                                  getIn(touched, name) && getIn(errors, name)
                                )}
                                helperText={
                                  getIn(touched, name) &&
                                  getIn(errors, name) &&
                                  getIn(errors, name)
                                }
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                required={required}
                                inputProps={{
                                  maxLength: 50,
                                }}
                              ></TextField>
                            </div>
                          );
                        } else if (type === "phone") {
                          return (
                            <div
                              className="form-group col-md-6 col-lg-4"
                              key={name + ind}
                            >
                              <TextField
                                label={label}
                                name={name}
                                onChange={handleChange}
                                value={values[name]}
                                aria-label="text-field"
                                fullWidth
                                error={Boolean(
                                  getIn(touched, name) && getIn(errors, name)
                                )}
                                helperText={
                                  getIn(touched, name) &&
                                  getIn(errors, name) &&
                                  getIn(errors, name)
                                }
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputComponent:
                                    type === "phone" ? TextMaskCustom : Number,
                                }}
                                required={required}
                              ></TextField>
                            </div>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                {/* Submit */}
                <div className="row">
                  <div className="mx-auto custom-submit-btn">
                    <button type="submit" disabled={props.isSubmitting}>
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      {/* Start of Error Dialog */}
      <Dialog
        fullWidth={true}
        open={error}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <DialogTitle id="max-width-dialog-title">
            {" "}
            <div className="text-center p-3">
              <img src={CBSLOGO} alt="logo" className="img-fluid" />
            </div>
          </DialogTitle>

          <DialogContentText className="text-center text-danger">
            {errorMessage ||
              "Please try again. We apologize for any inconvenience."}
          </DialogContentText>
          <div className="text-center">
            <Button
              type="btn"
              className="btn"
              onClick={handleClose}
              color="primary"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* End of Error Dialog */}
      {/* Start of Loading */}
      {loading && (
        <div className="custom-loader">
          <div className="semiTransparenDiv"></div>
          <CircularProgress />
        </div>
      )}
      {/* End of Loading */}
    </div>
  );
};

export default PreForm;
